import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import ScrollTop from 'src/hooks/useScrollTop';
import TagManager from 'react-gtm-module'
import 'nprogress/nprogress.css';
import { Provider } from 'react-redux';
import store from 'src/store';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { AuthProvider } from 'src/contexts/JWTAuthContext';
import { AuthProviderLayout } from 'src/contexts/LayoutContext';
import { registerLicense } from '@syncfusion/ej2-base'


const tagManagerArgs = {
  gtmId: 'GTM-5RGN55WB'
}

TagManager.initialize(tagManagerArgs)

registerLicense('Ngo9BigBOggjHTQxAR8/V1NGaF5cXmdCdkxwWmFZfV1gcF9CZVZQRWY/P1ZhSXxQdkJjXn5YdXZWRGJcWUU=')
// registerLicense('Ngo9BigBOggjHTQxAR8/V1NGaF5cXmdCeUx3QXxbf1xzZFBMY1pbR35PIiBoS35RdUVkWXhfd3dTRWhdV0N2')


ReactDOM.render(
  <HelmetProvider>
    <Provider store={store}>
      <SidebarProvider>
        <BrowserRouter>
          <ScrollTop />
          <AuthProvider>
            <AuthProviderLayout>
              <App />
            </AuthProviderLayout>
          </AuthProvider>
        </BrowserRouter>
      </SidebarProvider>
    </Provider>
  </HelmetProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
